import { render, staticRenderFns } from "./AfterClassTable.vue?vue&type=template&id=78b5f1da&scoped=true&"
import script from "./afterclasstable.js?vue&type=script&lang=js&"
export * from "./afterclasstable.js?vue&type=script&lang=js&"
import style0 from "./AfterClassTable.vue?vue&type=style&index=0&id=78b5f1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b5f1da",
  null
  
)

export default component.exports